import { ReactNode } from "react";
import { DesktopAdminHeader } from "./DesktopAdminHeader";
import { DesktopAdminSidebar } from "./DesktopAdminSidebar";
import { AppFooter } from "@/components/AppFooter";

interface DesktopAdminLayoutProps {
  children: ReactNode;
  onLogout: () => void;
}

export function DesktopAdminLayout({ children, onLogout }: DesktopAdminLayoutProps) {
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-background font-body">
      <DesktopAdminHeader />
      <div className="flex flex-1 overflow-hidden">
        <DesktopAdminSidebar onLogout={onLogout} />
        <main className="desktop-admin-content flex-1 overflow-y-auto bg-background p-5 lg:p-8">
          <div className="mx-auto max-w-[1440px]">
            {children}
            <AppFooter />
          </div>
        </main>
      </div>
    </div>
  );
}
